/**
 * useStudentValidateEmailData — la relecture du compte de « Valider l'email ».
 *
 * Comme `ValidateEmailScreen.js` : le compte relu une demi-seconde après l'ouverture (l'élève arrive
 * souvent de sa boîte mail, le lien déjà cliqué), et « Actualiser » qui le relit à la demande. Et, de
 * plus (Wajih, 20/10), à chaque retour dans l'app (`useOnReturnToApp` : le premier plan sur mobile,
 * l'onglet revu sur le web) : l'élève qui revient de sa boîte mail après avoir cliqué le lien voit
 * l'écran se fermer seul, sans toucher « Actualiser ». Le réducteur range la réponse dans
 * `currentUser.object`, que le view-model lit (patron A).
 */
import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { useOnReturnToApp } from "../../../hooks/useOnReturnToApp"

/** Le délai de l'ancien écran avant sa première relecture. */
export const FIRST_READ_DELAY_MS = 500

export function useStudentValidateEmailData() {
    const dispatch = useDispatch()

    const check = useCallback(() => {
        dispatch(apiRequest(authService.getUser) as never)
    }, [dispatch])

    useEffect(() => {
        const timer = setTimeout(check, FIRST_READ_DELAY_MS)
        return () => clearTimeout(timer)
    }, [check])

    useOnReturnToApp(check)

    return { check }
}
